const key = 'client-diagnostics-v1'

export function newRequestId () {
  if (!window.crypto || !window.crypto.getRandomValues) return ''
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
}

// A bounded local record suitable for support export. Deliberately omit token,
// URL/query, request/response bodies, error messages and business identifiers.
export function recordClientEvent (kind, details = {}) {
  try {
    let events = JSON.parse(sessionStorage.getItem(key) || '[]')
    if (!Array.isArray(events)) events = []
    const event = { at: new Date().toISOString(), kind: String(kind).replace(/[^a-z_-]/gi, '').slice(0, 40) }
    if (/^[A-Za-z0-9_-]{16,64}$/.test(details.requestId || '')) event.request_id = details.requestId
    if (Number.isFinite(details.duration)) event.duration_ms = Math.max(0, Math.round(details.duration))
    if (Number.isFinite(details.status)) event.status = details.status
    if (/^[A-Za-z]*Error$/.test(details.name || '')) event.error_type = details.name
    const frames = String(details.stack || '').match(/[A-Za-z0-9_.-]+\.js:\d+:\d+/g)
    if (frames) event.frames = frames.slice(0, 5)
    sessionStorage.setItem(key, JSON.stringify(events.concat([event]).slice(-20)))
  } catch (_) { /* Diagnostics must never interfere with navigation. */ }
}

export function exportClientDiagnostics () {
  let data = '[]'
  try { data = sessionStorage.getItem(key) || '[]' } catch (_) {}
  const url = URL.createObjectURL(new Blob([data], { type: 'application/json' }))
  const link = document.createElement('a')
  link.href = url
  link.download = 'page-diagnostics.json'
  link.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export function installClientDiagnostics (Vue) {
  const prior = Vue.config.errorHandler
  Vue.config.errorHandler = (error, vm, info) => {
    recordClientEvent('vue_error', error || {})
    if (prior) prior(error, vm, info)
  }
  window.addEventListener('error', event => recordClientEvent('window_error', event.error || {}))
  window.addEventListener('unhandledrejection', event => recordClientEvent('unhandled_rejection', event.reason || {}))
}



// WEBPACK FOOTER //
// ./src/utils/client-diagnostics.js